import { loadingConstants } from '../_constants';

export function loading(state = {}, action) {
    switch (action.type) {
      case loadingConstants.START:
        return {
          type: true
        };
      case loadingConstants.STOP:
        return {
          type: false
        };
      case loadingConstants.CLEAR:
        return {};
      default:
        return state
    }
  }



// WEBPACK FOOTER //
// ./src/_reducers/loading.reducer.js